import * as React from 'react'
import clsx from 'clsx'
import * as plume from '@ulule/owl-kit-components/next'

import { Container } from '../../_shared/Container'
import styles from './ContactCards.module.css'

export function ContactCards(): React.ReactElement {
  return (
    <section className={styles.cards} id="contact">
      <Container>
        <div className={styles.cards__grid}>
          <article id="ressources" className={clsx(styles.card, styles.cardHoverBlue)}>
            <div className={clsx(styles.card__icon, styles.cardIconBlue)}>
              <plume.glyphs.stroke.Download />
            </div>
            <h3 className={styles.card__title}>Logo, stickers &amp; assets</h3>
            <p className={styles.card__body}>
              Logos officiels (PNG, SVG, AI), stickers de campagne et macarons « Financé sur Ulule » — libres de
              diffusion sur vos supports.
            </p>
            <div className={styles.card__cta}>
              <plume.Link href="/about/logos/" kind="primary" tinted>
                Accéder aux ressources →
              </plume.Link>
            </div>
          </article>

          <article className={clsx(styles.card, styles.cardYellow)}>
            <div className={clsx(styles.card__icon, styles.cardIconYellow)}>
              <plume.glyphs.stroke.Letter />
            </div>
            <h3 className={styles.card__title}>Contact presse</h3>
            <p className={styles.card__body}>
              Journaliste ou blogueur ? Notre équipe est disponible pour répondre à vos questions et vous fournir les
              éléments nécessaires.
            </p>
            <div className={styles.card__cta}>
              <plume.RoundButton as="a" href="mailto:press@ulule.com" color="yellow">
                Envoyer un mail
              </plume.RoundButton>
            </div>
          </article>

          <article className={clsx(styles.card, styles.cardHoverRed)}>
            <div className={clsx(styles.card__icon, styles.cardIconRed)}>
              <plume.glyphs.stroke.People />
            </div>
            <h3 className={styles.card__title}>Interviewer un porteur de projet</h3>
            <p className={styles.card__body}>
              Vous pouvez contacter directement les équipes des projets (
              <a href="https://support.ulule.com/hc/articles/211813109" target="_blank" rel="noopener noreferrer">
                mode d'emploi
              </a>
              ) ou nous écrire pour qu'on fasse le lien.
            </p>
            <div className={styles.card__cta}>
              <plume.Link href="/discover/" kind="primary" tinted>
                Trouver un projet →
              </plume.Link>
            </div>
          </article>
        </div>
      </Container>
    </section>
  )
}
